import IconPlus from '@apollo/icons/default/IconPlus.svg';
import { Button } from '@apollo/orbit';
import React, { ComponentProps } from 'react';

export const NewHeaderButton = ({
  isSharedHeader,
  className,
  ...props
}: ComponentProps<typeof Button> & { isSharedHeader: boolean }) => {
  return (
    <Button
      {...props}
      className={className}
      type="button"
      variant="hidden"
      size="sm"
      leftIcon={<IconPlus />}
    >
      {isSharedHeader ? 'New shared header' : 'New header'}
    </Button>
  );
};
